import BarChartComponent from '@/components/ui/charts/BarChartComponent';
import { useMemo } from 'react';

export type DailyConsultationsByMainReasonProps = {
    data: Array<{ reason: string, count: number }>;
    title: string;
    date: string;
}

function DailyConsultationsByMainReasonComponent(props: DailyConsultationsByMainReasonProps) {
    const { data, title, date } = props;

    const transformedData = useMemo(() => data.map(item => ({
        label: item.reason,
        values: [{ subLabel: date, value: item.count }]
    })), [data, date]);

    return <BarChartComponent data={transformedData} title={title} />;
}

export default DailyConsultationsByMainReasonComponent;
